import { createContext } from 'react';
import { IAuthContext } from '../../domain/types/IAuthContext';

export default createContext<IAuthContext>(null!);
